import Auth from "./modules/auth.js";
import User from "./modules/user.js";
import Visualizer from "./modules/visualizer.js";
import Brand from "./modules/brand.js";
import Company from "./modules/company.js";
import Stores from "./modules/store.js";
import Location from "./modules/location.js";
import Porders from "./modules/porders.js";
import Orders from "./modules/orders.js";
import Containers from "./modules/containers.js";
import Morders from "./modules/morders.js";
import Receptions from "./modules/receptions.js";
import Providers from "./modules/providers.js";
import Types from "./modules/types.js";
import Inventories from "./modules/inventories.js";
import ReceptionBoxes from "./modules/reception_boxes.js";
import Common from "./modules/common.js";
import Device from "./modules/device.js";
import Printer from "./modules/printer.js";
import Area from "./modules/area.js";
import Chart from "./modules/chart.js";
import Alarm from "./modules/alarm.js";
import Nms from "./modules/nms.js";
import Epc from "./modules/epc.js";

export const API_BASE = process.env.VUE_APP_API_BASE;
export const NMS_API_BASE = process.env.VUE_APP_API_NMS;

export default function Api(store) {
  return {
    baseUrl: API_BASE,
    baseNMSUrl: NMS_API_BASE,
    token: null,
    $store: store,
    auth: Auth(store),
    user: User(store),
    visualizer: Visualizer(store),
    brand: Brand(store),
    company: Company(store),
    store: Stores(store),
    location: Location(store),
    porders: Porders(store),
    orders: Orders(store),
    containers: Containers(store),
    morders: Morders(store),
    receptions: Receptions(store),
    providers: Providers(store),
    types: Types(store),
    inventories: Inventories(store),
    reception_boxes: ReceptionBoxes(store),
    common: Common(store),
    device: Device(store),
    printer: Printer(store),
    area: Area(store),
    chart: Chart(store),
    alarm: Alarm(store),
    nms: Nms(store),
    epc: Epc(store)
  };
}

export function dispatchError(store, error) {
  error && console.error(error.response.detail);
  // store.dispatch('globalErrorMessage', {
  //   message: error,
  //   type: 'error'
  // })
}

export function config(store) {
  return {
    mode: "no-cors",
    headers: {
      Accept: "application/json",
      Authorization: "Token " + store.state.auth.token
    }
  };
}
export function nmsconfig(store) {
  return {
    mode: "no-cors",
    headers: {
      Accept: "application/json",
      Authorization: "token " + store.state.auth.token
    }
  };
}
